import { HazardIdEnum } from "../../riskAssessment/hazardIdEnum";

export const pdfTableHazardIds = [
  HazardIdEnum.SeismicClassificationIta,
  //
  HazardIdEnum.InlandFloodIta10y,
  HazardIdEnum.InlandFloodIta20y,
  HazardIdEnum.InlandFloodIta50y,
  HazardIdEnum.InlandFloodIta100y,
  HazardIdEnum.InlandFloodIta500y,
  //

  HazardIdEnum.CoastalFlood10y,
  HazardIdEnum.CoastalFlood30y,
  HazardIdEnum.CoastalFlood100y,
  HazardIdEnum.CoastalFlood300y,
  HazardIdEnum.CoastalFlood1000y,
  HazardIdEnum.FlashFloodIta3h,
  HazardIdEnum.FlashFloodIta24h,
  HazardIdEnum.FlashFloodIta48h,
  HazardIdEnum.FlashFloodIta72h,
  HazardIdEnum.HailItaLarge,
  HazardIdEnum.HailItaExLarge,
  HazardIdEnum.HighWindItaSevere,
  HazardIdEnum.HighWindItaExtreme,
  HazardIdEnum.SnowIta5cm,
  HazardIdEnum.SnowIta25cm,
  HazardIdEnum.LightningStrikeIta,
  HazardIdEnum.WindItaANIA,
  HazardIdEnum.LightningStrikeItaANIA,
  HazardIdEnum.HailItaANIA,
  HazardIdEnum.PrecipitationIta75mmANIA,
  HazardIdEnum.SnowIta30cmANIA,
  HazardIdEnum.InlandFloodIspra,
  HazardIdEnum.LandslideRiskIspra,
  HazardIdEnum.SeismicRiskHowden,
  HazardIdEnum.SeismicRiskHowden2,
  HazardIdEnum.InlandFloodHowden,
  HazardIdEnum.InlandFloodHowden58,
  HazardIdEnum.InlandFloodHowden56,
  HazardIdEnum.RealeGroupHail,
  HazardIdEnum.RealeGroupWind,
];
